module.exports = __webpack_public_path__ + "img/timeline_mainevent-1.d78e2e74.jpg";